// @flow
import apiService from './api-service';
import publicApiService from './public-api-service';

class AuthorizeRequestService {
  checkValidity(token: string): Promise<any> {
    return publicApiService
      .get(`/public/information_requests/${token}/check_validity`);
  }

  verifyUser = (tokens: Array<string>, userParams: Object) => {
    return apiService
      .post('/verify_unregistered',
        {
          dob: userParams.dob,
          hcn: userParams.hcn,
          province: userParams.province,
          information_request_tokens: tokens
        })
      .then((response) => response);
  }

  updateRequestPatient = (tokens: Array<string>, user:Object) => {
    return apiService.post('/update_unregistered', {
      user,
      information_request_tokens: tokens
    });
  }

  create(blob: any, accessToken: string): Promise<any> {
    return publicApiService
      .upload('/public/information_requests/authorize',
        blob, 'signature',
        { consent_given: true },
        accessToken
      )
      .then((response) => response)
      .catch((err) => { throw err.error; });
  }

  downloadConsentForm(accessToken: string, requestToken: string): Promise<any> {
    return publicApiService
      .get(`/public/information_requests/${requestToken}/filled_form`,
        {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      );
  }

  downloadInstitutionLogo(accessToken: string): Promise<any> {
    return publicApiService
      .get('/public/institutions/logo',
        {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      );
  }
}

export default new AuthorizeRequestService();


// WEBPACK FOOTER //
// ./src/services/authorize-request-service.js